module.exports = __webpack_public_path__ + "static/media/loading13.dfa490f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading13.png
// module id = 198
// module chunks = 0